import { render, staticRenderFns } from "./CompanyUserShow.vue?vue&type=template&id=18629424"
import script from "./CompanyUserShow.vue?vue&type=script&lang=ts"
export * from "./CompanyUserShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports